import React from 'react';
import Step from './Step';
import { isMobile } from 'react-device-detect';
import { getCurrentHistory, steps } from '../IdfSaleEnums';

export default function StepBar(props) {
    const store = props.idfStore;
    let currentProcessSteps = getCurrentHistory(store);
    let stepsToDisplay = steps.filter(step => currentProcessSteps.some(processStep => step.value.includes(processStep)));
    let totalSteps = stepsToDisplay.length;
    let currentStep = stepsToDisplay.findIndex(step => step.value.includes(store.steps.current));
    const barWidth = 110;
    const spaceWidth = 12;
    let totalWidth = barWidth * totalSteps + (spaceWidth * (totalSteps - 1));

    const calculateProgress = () => {
        let stepWidth = 0;
        if (currentStep === stepsToDisplay.length) {
            stepWidth = 100;
        } else {
            stepWidth = (100 / totalSteps) * (currentStep + 0.5);
        }
        return stepWidth;
    };



    return (
        <div className='idf-step-bar'>
            <div className={`idf-step-progress`} style={{ width: `${totalWidth}px` }} >
                <span className={`idf-progress-indicator step${currentStep}`} style={{ width: `${calculateProgress()}%` }} />
            </div>
            <div className='idf-steps-container'>
                {stepsToDisplay.map((step, i) => (
                    <React.Fragment key={i}>
                        <Step stepTitle={step.title} index={i} stepValue={step.value} currentStep={currentStep} />
                        {i < totalSteps - 1 && !isMobile && <span className='idf-blank'></span>}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}
